module.exports = __webpack_public_path__ + "assets/cbe5c6e731c3c179f1b03f3b60f76368.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/prev.mp3
 ** module id = 371
 ** module chunks = 0
 **/